import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Mail, MessageCircle, Send } from "lucide-react";
import { Nav } from "@/components/landing/Nav";
import { Footer } from "@/components/landing/Footer";
import { useContactLink, CONTACT_CHANNEL } from "@/utils/contact";
import { trackEvent } from "@/utils/tracking";
import { setPageMeta } from "@/utils/seo";

const SUPPORT_EMAIL = (process.env.REACT_APP_SUPPORT_EMAIL || "").trim();

export default function Contact() {
  const link = useContactLink("Halo NALURA! Saya ingin bertanya.");

  useEffect(() => {
    window.scrollTo(0, 0);
    setPageMeta("Kontak — NALURA", "Hubungi tim NALURA untuk pertanyaan seputar produk, pre-order, kerja sama, atau data pribadi Anda.");
  }, []);

  return (
    <div className="bg-[#FBF7EE] text-[#211B10] min-h-screen" data-testid="contact-page">
      <Nav />
      <main className="pt-32 md:pt-40 pb-24 max-w-3xl mx-auto px-6 md:px-12">
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-[#A67C1E] mb-6">Kontak</p>
        <h1 className="font-display tracking-tighter text-4xl sm:text-5xl mb-6">Kami senang mendengar dari Anda.</h1>
        <p className="text-base text-[#211B10]/65 leading-relaxed mb-10 max-w-xl">
          Ada pertanyaan sebelum membeli, soal pre-order parfum, kerja sama, atau permintaan terkait data pribadi Anda?
          Hubungi kami lewat kanal di bawah — kami biasanya membalas dalam 1×24 jam.
        </p>

        <div className="space-y-4 mb-12">
          {link && (
            <a
              data-testid="contact-chat-button"
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent("klik_kontak", { lokasi: "halaman-kontak" })}
              className="inline-flex items-center gap-3 bg-[#A67C1E] text-[#FBF7EE] font-medium text-sm uppercase tracking-[0.12em] px-8 py-4 hover:bg-[#211B10] transition-colors duration-300"
            >
              {CONTACT_CHANNEL === "telegram" ? <Send className="w-4 h-4" /> : <MessageCircle className="w-4 h-4" />}
              Chat {CONTACT_CHANNEL === "telegram" ? "Telegram" : "WhatsApp"}
            </a>
          )}
          {SUPPORT_EMAIL && (
            <p className="flex items-center gap-3 text-sm text-[#211B10]/70" data-testid="contact-email">
              <Mail className="w-4 h-4 text-[#A67C1E]" />
              <a href={`mailto:${SUPPORT_EMAIL}`} className="underline hover:text-[#A67C1E]">{SUPPORT_EMAIL}</a>
            </p>
          )}
        </div>

        <p className="text-xs text-[#211B10]/55 leading-relaxed">
          Untuk informasi tentang bagaimana kami memproses data Anda, baca{" "}
          <Link to="/kebijakan-privasi" className="underline text-[#A67C1E]">Kebijakan Privasi</Link>.
        </p>
      </main>
      <Footer />
    </div>
  );
}
